<template>
	<svg
		:class="[cleanIcon ? 'clean-svg-icon' : 'svg-icon', className]"
		:style="iconStyle"
		aria-hidden="true"
		v-on="$listeners"
	>
		<use :xlink:href="iconName" :fill="color" />
	</svg>
</template>

<script>
import to from 'await-to-js';

export default {
	name: 'SvgIcon',
	props: {
		// 图标名称（不需要 .svg 后缀）
		name: {
			type: String,
			required: true
		},
		// 图标颜色，通过 CSS 的 currentColor 实现
		color: {
			type: String,
			default: 'currentColor'
		},
		width: {
			type: String,
			default: ''
		},
		height: {
			type: String,
			default: ''
		},
		// 自定义类名
		className: {
			type: String,
			default: ''
		},
		// 不走默认样式，可配合 width 和 height 使用
		cleanIcon: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		iconName() {
			return `#icon-${this.name}`;
		},
		iconStyle() {
			const style = {};
			if (this.color) {
				style.color = this.color;
			}
			if (this.width) {
				style.width = this.width;
			}
			if (this.height) {
				style.height = this.height;
			}
			return style;
		}
	},
	watch: {
		name: {
			immediate: true,
			handler(newName) {
				if (newName) {
					this.loadIcon(newName);
				}
			}
		}
	},
	methods: {
		async loadIcon(iconName) {
			// 动态导入 SVG 文件，svg-sprite-loader 会自动处理
			// 使用 await-to-js 处理异步错误
			const [err] = await to(import(/* webpackChunkName: "svg-icon" */ `@/assets/icons/${iconName}.svg`));

			if (err) {
				console.warn(
					`[SvgIcon] 图标 "${iconName}" 加载失败，请确保文件存在于 src/assets/icons/ 目录下:`,
					err.message || err
				);
				return;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>
